import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import primeLogo from 'images/prime/jumbo-prime-icon.svg';
import StorageService from 'services/StorageService/';
import { actionsType, feedbackRegister } from 'config/constants';
import {HtmlParse} from 'utils';
import style from './style.scss'; //NOSONAR

const FeedbackRegister = () => {
    const [userName, setUserName] = useState(null);
    const userData = StorageService.getSecureItem('userData');

    useEffect(() => {
        setUserName(userData ? userData.firstName : '');

        if(typeof window !== 'undefined' && window.location.pathname.indexOf('/login-page') !== -1){
            const urlCallback = window.location && window.location.search ? window.location.search.replace('?callback=','') : '';
            window.location.href = urlCallback;
        }

        return function cleanup() {
            setTimeout(() => {
                PubSub.dispatch(actionsType.DRAWER.FEEDBACK_REGISTER_CLOSE)
            }, 0)
        }
    }, []);

    const goBack = () => {
        setTimeout(() => PubSub.dispatch(actionsType.DRAWER.FEEDBACK_REGISTER_CLOSE), 0);
    }

    const goRegisterPrime = () => {
        setTimeout(() => PubSub.dispatch(actionsType.DRAWER.FEEDBACK_REGISTER_CLOSE), 0);
        setTimeout(() => PubSub.dispatch(actionsType.DRAWER.LOGIN_CLOSE), 0);
        setTimeout(() => PubSub.dispatch(actionsType.DRAWER.REGISTER_PRIME_OPEN), 0)
    }

    return (
        <div className="drawer-container">
            <h1 className="drawer-title">¡Te damos la bienvenida, {userName}!</h1>
            <div className={'drawer-scroll feedback-register-content active'}>
                <form className="form-container">
                    <div className="feedback-register-container-message">
                        
                        <label className="label-warning">Tu cuenta ya ha sido creada y podrás usarla también para ingresar en  {feedbackRegister} y Spid</label>
                    </div>
                    <div className="drawer-feedback-register-suscription-prime">
                        <span className="drawer-feedback-register-suscription-prime-info ">¿Quieres continuar tu suscripción?</span>
                        <div className="drawer-feedback-register-suscription-prime-logo">{HtmlParse(primeLogo)}</div>
                    </div>

                </form>
            </div>
            <div className="drawer-actions">
                <button className='secundary-btn' onClick={goBack}>Cancelar</button>
                <button type="submit" className='primary-btn' onClick={goRegisterPrime}>
                    <span className={'btn-span-enter'}>Continuar Suscripción</span>
                </button>
            </div>
        </div>
    );
}

export default FeedbackRegister;
